import { base } from "../base";
import { base_v2 } from "../base_v2";

async function addNewPromotion(data) {
  return base.post("catalogs/promotions", data);
}

async function updatePromotion(data) {
  return base.put("catalogs/promotions", data);
}

async function getListPromotion(data) {
  return base.get("catalogs/promotions", data);
}

async function getListPromotionCustomerGroup(data) {
  return base.get("catalogs/discount/customer-groups", data);
}

async function getListPromotionBrand(data) {
  return base.get("catalogs/discount/trademarks", data);
}

async function getListPromotionDistributor(data) {
  return base.get("catalogs/discount/distributors", data);
}

async function checkPromotion(data) {
  return base.post("services/purchase-order/valid-promotion", data);
}

async function cancelRuleCustomerGroup(data) {
  return base.put("catalogs/discount/customer-groups", data);
}

async function cancelRuleBrand(data) {
  return base.put("catalogs/discount/trademarks", data);
}

async function cancelRuleDistributor(data) {
  return base.put("catalogs/discount/distributors", data);
}

async function createRuleCustomerGroup(data) {
  return base.post("catalogs/discount/customer-groups", data);
}

async function createRuleTrademark(data) {
  return base.post("catalogs/discount/trademarks", data);
}

async function createRuleDistributor(data) {
  return base.post("catalogs/discount/distributors", data);
}

async function checkPromotionTotalOrder(data) {
  return base.post("services/check-promotion", data);
}


async function getListPromotionOrder(data) {
  return base_v2.get("services/get-promotion", data);
}

async function checkPromotionTotalOrderV2(data) {
  return base_v2.post("services/check-promotion", data);
}

export const promotionService = {
  addNewPromotion,
  updatePromotion,
  getListPromotion,
  getListPromotionCustomerGroup,
  getListPromotionBrand,
  getListPromotionDistributor,
  checkPromotion,
  cancelRuleCustomerGroup,
  cancelRuleBrand,
  cancelRuleDistributor,
  createRuleCustomerGroup,
  createRuleTrademark,
  createRuleDistributor,
  checkPromotionTotalOrder,
  getListPromotionOrder,
  checkPromotionTotalOrderV2
};
